module.exports = __webpack_public_path__ + "media/categories/7019-402dd5ba.svg";